import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token,       setToken]       = useState(localStorage.getItem('admin_token'));
  const [adminEmail,  setAdminEmail]  = useState(localStorage.getItem('admin_email'));
  const [adminRole,   setAdminRole]   = useState(localStorage.getItem('admin_role')   || 'super_admin');
  const [adminName,   setAdminName]   = useState(localStorage.getItem('admin_name')   || '');
  const [permissions, setPermissions] = useState(() => {
    try { return JSON.parse(localStorage.getItem('admin_permissions') || '["all"]'); }
    catch { return ['all']; }
  });

  const login = (tok, email, role = 'super_admin', name = '', perms = ['all']) => {
    localStorage.setItem('admin_token',       tok);
    localStorage.setItem('admin_email',       email);
    localStorage.setItem('admin_role',        role);
    localStorage.setItem('admin_name',        name);
    localStorage.setItem('admin_permissions', JSON.stringify(perms));
    setToken(tok);
    setAdminEmail(email);
    setAdminRole(role);
    setAdminName(name);
    setPermissions(perms);
  };

  const logout = () => {
    ['admin_token','admin_email','admin_role','admin_name','admin_permissions'].forEach(k => localStorage.removeItem(k));
    setToken(null); setAdminEmail(null);
    setAdminRole('super_admin'); setAdminName(''); setPermissions(['all']);
  };

  // true if super_admin OR has the specific permission
  const hasPerm = (key) => permissions.includes('all') || permissions.includes(key);

  return (
    <AuthContext.Provider value={{ token, adminEmail, adminRole, adminName, permissions, login, logout, isAdmin: !!token, hasPerm }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
